import * as React from 'react';
import * as moment from 'moment-timezone';
import { Text, TextStyle, Inset, InlineChildren, InsetSize, } from '@doordash/design-language';
import { EntryContainer, EntryTileButtonsWrapper, PreCheckoutText, SpendingLimitText, DeleteCartButton, } from './GroupOrderEntryStyles';
import { CalendarStrings } from '../Calendar/CalendarStrings';
import { useCalendarViewContext } from '../Calendar/CalendarViewContext';
import StoreImageView from './StoreImageView';
import { GroupOrderEntryTestId } from '../../../../../core/Common/testId';
var EntryViewCartCreated = function (_a) {
    var entry = _a.entry, showSpendingLimit = _a.showSpendingLimit, spendingLimitDescription = _a.spendingLimitDescription, _b = _a.debugMode, debugMode = _b === void 0 ? false : _b, onDeleteEntry = _a.onDeleteEntry;
    var isEmployeeView = useCalendarViewContext().isEmployeeView;
    var preCheckoutDescription = moment(entry.targetDeliveryTime)
        .subtract(1, 'days')
        .format('h:mm A, ddd, MMM D');
    var contentStrings = CalendarStrings.groupOrderEntry.cartCreated;
    return (React.createElement(EntryContainer, null,
        React.createElement(StoreImageView, { entry: entry },
            React.createElement(EntryTileButtonsWrapper, null,
                React.createElement(InlineChildren, { size: InlineChildren.Sizes.TagPaddingHorizontalMedium }, !isEmployeeView && (React.createElement(DeleteCartButton, { "data-testid": GroupOrderEntryTestId.DeleteCartButton, onClick: function () { return onDeleteEntry(entry); } }))))),
        React.createElement(Inset, { verticalSize: InsetSize.XSmall, horizontalSize: InsetSize.None },
            React.createElement(Text, { styles: TextStyle.Label2Emphasis }, entry.store.name),
            React.createElement(PreCheckoutText, { children: contentStrings.availableAt() + " " + preCheckoutDescription }),
            React.createElement(SpendingLimitText, { visibility: showSpendingLimit, children: spendingLimitDescription })),
        debugMode && React.createElement(Text, null, entry.targetDeliveryTime)));
};
export default EntryViewCartCreated;
